export const FeatureFlag = {
  Beta: "beta",
  CloudThemeSelector: "cloud-theme-selector",
  ColocationRackEnergyConsumption: "colocation-rack-energy-consumption",
  DbaasV2: "dbaas-v2",
  EarlyAccess: "early-access",
  KvmGpu: "kvm-gpu",
  NetworkCircuits: "network-circuits",
  PrivateNetworkTopology: "private-network-topology",
  ResellerPricing: "reseller-pricing",
  ServerPlans: "server-plans",
  SupportChallenge: "support-challenge",
} as const;

export type FeatureFlagId = (typeof FeatureFlag)[keyof typeof FeatureFlag];
